/* 🤖 this file was generated by svg-to-ts */
export const emperorIconDataDownload9: {
  name: 'data_download_9';
  data: string;
} = {
  name: 'data_download_9',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M18 18.001v2H6v-2H4v2c0 1.1.89 2 2 2h12c1.1 0 2-.9 2-2v-2h-2Z"/><path d="M11.293 15.7c.19.19.45.29.7.29 .25 0 .51-.1.7-.3l5-5c.28-.29.37-.72.21-1.09 -.16-.38-.52-.62-.93-.62h-2v-6c0-.56-.45-1-1-1h-4c-.56 0-1 .44-1 1v6h-2c-.41 0-.77.24-.93.61 -.16.37-.07.8.21 1.09l5 5Zm-1.3-4.71c.55 0 1-.45 1-1v-6h2v6c0 .55.44 1 1 1h.58l-2.59 2.58 -2.59-2.59h.58Z"/></g></svg>`,
};
